import { isString } from "lodash";
import { mergeLocations, useAuditContext } from "../AuditContextProvider";
import { trackEvent } from "../trackEvent";
import { TrackEventParams } from "../types";

/** Adds location to event */
export const useTrackEvent = () => {
    const context = useAuditContext();

    return (event: string | TrackEventParams) => {
        const { eventName, location, ...data } = isString(event) ? ({ eventName: event } as TrackEventParams) : event;
        const eventLocation = location ? mergeLocations(context.location, location) : context.location;
        const payload = { ...data, location: eventLocation };
        trackEvent(eventName, payload);
    };
};
